import { Form, FormItemProps, Input, InputProps } from 'antd';
import { Rule } from 'antd/es/form';

const defaultRules: Rule[] = [{ max: 100 }];

interface InputNameProps {
  formItemProps?: FormItemProps;
  inputProps?: InputProps;
}

export function InputName({
  formItemProps: { rules = [], label = 'Name', ...props } = {},
  inputProps,
}: InputNameProps) {
  return (
    <Form.Item label={label} name="name" {...props} rules={[...defaultRules, ...rules]}>
      <Input placeholder={label as string} {...inputProps} />
    </Form.Item>
  );
}

export default {
  InputName,
};
